/* eslint-disable object-property-newline */
/* eslint-disable no-unneeded-ternary */
import React, { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core/'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import plusIcon from '../../../../../../../assetss/img/plusIcon.svg'
import closeIcon from '../../../../../../../assetss/img/closeIcon.svg'
import c from 'classnames'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers'
import { v4 as uuidv4 } from 'uuid'
import './index.scss'

const categoryFilter = [
  {
    title: 'Количество дней, которое пользователь не заходил в систему;',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'input', name: 'lastOnlineAt', index: '', id: uuidv4()?.toString(),
  },
  {
    title: 'Количество встреч у пользователя;',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'input', name: 'meetingsCount', index: '', id: uuidv4()?.toString(),
  },
  {
    title: 'Количество историй у пользователя;',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'input', name: 'storiesCount', index: '', id: uuidv4()?.toString(),
  },
  {
    title: 'Время отправки письма',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: new Date(), optionItem: '', inputType: 'time', index: '', id: uuidv4()?.toString(),
  },
  { title: 'Отправить всем', id: uuidv4()?.toString() },
  {
    title: 'Отправить на указаний Email',
    active: false, value: '', optionItem: 'empty', inputType: 'input', index: '$value', type: 'text', name: 'email', id: uuidv4()?.toString(),
  },
  {
    title: 'Город', options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'select', name: 'town', index: '', id: uuidv4()?.toString(),
  },
]

const categoryFilterOther = [
  {
    title: 'Количество дней, которое пользователь не заходил в систему;',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'input', index: '', id: uuidv4()?.toString(),
  },
  {
    title: 'Количество встреч у пользователя;',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'input', name: 'meetingsCount', index: '', id: uuidv4()?.toString(),
  },
  {
    title: 'Количество историй у пользователя;',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'input', name: 'storiesCount', index: '', id: uuidv4()?.toString(),
  },
  {
    title: 'Время отправки письма',
    options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }, { title: 'Больше', item: '$more' }, { title: 'Меньше', item: '$less' }],
    active: false, value: new Date(), optionItem: '', inputType: 'time', index: '', id: uuidv4()?.toString(),
  },
  {
    title: 'Отправить на указаний Email',
    active: false, value: '', optionItem: 'empty', inputType: 'input', index: '$value', type: 'text', name: 'email', id: uuidv4()?.toString(),
  },
  {
    title: 'Город', options: [{ title: 'Ровно', item: '$value' }, { title: 'Не ровно', item: '$not' }],
    active: false, value: '', optionItem: '', type: 'number', inputType: 'select', name: 'town', index: '', id: uuidv4()?.toString(),
  },
]

const FilterSendEmail = ({ setAddedFilter, addedFilter, setTimeSend }) => {
  const [newItems, setNewItems] = useState(categoryFilter)
  const [disable, setDisable] = useState(false)
  const filterItem = (item, array, setArrey) => setArrey([...array]?.filter(({ title }) => title !== item))
  const [town, setTown] = useState('')

  useEffect(() => {
    if (addedFilter?.length) {
      addedFilter?.forEach(item => {
        if (item?.value) {
          setDisable(false)
        } else {
          setDisable(true)
        }
      })
    } else {
      setDisable(false)
    }
  }, [addedFilter])

  const selectOptions = (item, index) => {
    const updateOptionFilter = addedFilter?.map((i, ind) => index === ind ? { ...i, optionItem: item, index: indexSortFilter(item) } : i)
    setAddedFilter(updateOptionFilter)
  }

  const selectTown = () => {
    const updateOptionFilter = addedFilter?.map((i, ind) => i?.title === 'Город' ? { ...i, value: town?.value?.structured_formatting?.main_text, active: false } : i)
    setAddedFilter(updateOptionFilter)
  }

  useEffect(() => {
    if (town) {
      selectTown()
    }
  }, [town])

  const newOptions = item => {
    if (item === 'Ровно') {
      return '='
    } else if (item === 'Не ровно') {
      return '!='
    } else if (item === 'Больше') {
      return '>'
    } else if (item === 'Меньше') {
      return '<'
    } else if (item === 'Операция') {
      return ''
    }
  }

  const indexSortFilter = item => {
    if (item === 'Ровно') {
      return '$value'
    } else if (item === 'Не ровно') {
      return '$not'
    } else if (item === 'Больше') {
      return '$more'
    } else if (item === 'Меньше') {
      return '$less'
    } else if (item === 'Операция') {
      return ''
    }
  }

  const onChange = (e, index) => {
    const updateOptionFilter = addedFilter?.map((i, ind) => {
      if (index === ind) {
        if (i?.type === 'number') {
          return { ...i, value: e?.target?.value, active: false }
        } else {
          return { ...i, value: e?.target?.value, active: false }
        }
      } else {
        return i
      }
    })
    setAddedFilter(updateOptionFilter)
  }

  const handleDateChange = (date, index) => {
    const updateOptionFilter = addedFilter?.map((i, ind) => index === ind ? { ...i, value: date, active: false } : i)
    setAddedFilter(updateOptionFilter)
    setTimeSend(date)
  }

  return (
    <Grid className='wrapperFilter'>
      <Grid className='itemsBoxAdded'>
        {addedFilter?.map((item, index) => (
          <Grid className='boxFilterOption' key={item?.id}>
            <button className='itemFilterAdded'>
              <img
                onClick={() => {
                  setNewItems([...newItems, { ...item, active: false, optionItem: '', value: '' }])
                  filterItem(item?.title, addedFilter, setAddedFilter)
                }}
                className='plusIcon'
                src={closeIcon}
              /> {item?.title}
            </button>
            {item?.options?.length && (
              <select className='itemOptions' onChange={e => selectOptions(e?.target?.value, index)}>
                <option>Операция</option>
                {item?.options?.map(name => <option key={name}>{name?.title}</option>)}
              </select>
            )}
            {item?.optionItem && (
              item?.inputType === 'input' ? (
                <div className='itemInput'>
                  {newOptions(item?.optionItem)} <input value={item?.value} className={c('paramsInput', item?.type === 'text' && 'emailInput')} onChange={e => onChange(e, index)} />
                </div>
              ) : item?.inputType === 'time' ? (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    error={false}
                    variant='standard'
                    autoFocus={false}
                    multiline={false}
                    className='timeInputFilter'
                    id='time-picker'
                    value={item?.value}
                    onChange={date => handleDateChange(date, index)}
                    KeyboardButtonProps={{
                      'aria-label': 'change time',
                    }}
                    keyboardIcon={newOptions(item?.optionItem)}
                    InputAdornmentProps={{ position: 'start', variant: 'standard' }}
                  />
                </MuiPickersUtilsProvider>
              ) : item?.inputType === 'select' ? (
                <div className='adminInputRegister'>
                  {newOptions(item?.optionItem)}
                  <GooglePlacesAutocomplete
                    minLengthAutocomplete={1}
                    autocompletionRequest={{
                      types: ['geocode'],
                    }}
                    selectProps={{
                      value: town,
                      onChange: setTown,
                      placeholder: 'Your city',
                      defaultInputValue: '',
                    }}
                  />
                </div>
              ) : null
            )}
          </Grid>
        ))}
      </Grid>
      <Grid className='itemsBox'>
        {newItems?.map(item => (
          <button
            disabled={disable}
            key={item?.id}
            className={c('itemFilter', disable && 'itemDisable')}
            onClick={() => {
              if (item?.title === 'Отправить всем') {
                setNewItems(categoryFilterOther)
                setAddedFilter([{ ...item, active: true }])
              } else {
                filterItem(item?.title, newItems, setNewItems)
                setAddedFilter([...addedFilter, { ...item, active: true }])
              }
            }}
          >
            {item?.title} <img className='plusIcon' src={plusIcon} />
          </button>
        ))}
      </Grid>
    </Grid>
  )
}

export default FilterSendEmail
